import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {AbstractControl, FormControl, UntypedFormGroup} from '@angular/forms';
import {ToastService} from '../../../../main/services';
import {TenderAnalyticsSettingsService} from '../../../services';
import {User} from '../../../../auth/models';
import {PaymentTerms} from '../../../models';
import {PaymentTypesCollection} from '../../../../common/models/payment-type';
import {tenderAnalyticsPaymentTermsForm} from '../../../forms';
import {FormValidationErrorsHelper} from '../../../../common/helpers/forms/form-validation-errors-helper';
import {PAYMENT_TYPES} from '../../../../common/models/payment-type/payment-types';
import {Validators} from '../../../../common/forms';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'jft-tender-payment-terms',
    templateUrl: './payment-terms.component.html',
    styleUrls: ['payment-terms.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PaymentTermsComponent implements OnInit {

    public form: UntypedFormGroup;
    public paymentTerms: PaymentTerms;
    public paymentTypesCollection: PaymentTypesCollection;
    public loading: boolean = false;
    public tenderId: string;

    constructor(
        protected route: ActivatedRoute,
        private service: TenderAnalyticsSettingsService,
        private toast: ToastService,
        public user: User
    ) {

    }

    public ngOnInit() {
        let data = this.route.snapshot.data;
        let parentData = this.route.snapshot.parent.data;
        this.tenderId = this.route.snapshot.parent.parent.params.id;
        this.paymentTerms = data['payment_terms'];
        this.paymentTypesCollection = parentData['paymentTypesCollection'];

        this.initForm();

        // Tender Settings are read-only for non-Manager roles.
        if (!this.user.canManageAdvanced()) {
            this.form.disable();
        }
    }

    public initForm() {
        this.form = tenderAnalyticsPaymentTermsForm(this.paymentTerms);
    }

    public save() {
        if (this.form.invalid === true) {
            this.toast.error('Invalid data');
            return;
        }
        this.form.disable();
        this.loading = true;

        this.service.savePaymentTerms(this.form.value, this.tenderId)
          .pipe(finalize(() => this.form.enable()))
            .subscribe(
            data => {
                this.toast.success(`Preferred payment terms have been updated`);
                this.loading = false;
            },
            err => {
                this.form.enable();
                //this.toast.error(err)
            });
    }

    public onChangePreferredPaymentTerm() {
        if (this.form.controls.invoice_frequency.invalid) {
            this.form.controls.invoice_frequency.setValue(1)
        }
        if (this.form.controls.credit_terms.invalid) {
            this.form.controls.credit_terms.setValue(1)
        }
        if (this.form.controls.payment_type_id.invalid) {
            this.form.controls.payment_type_id.setValue(1)
        }
        this.onChangePaymentType(this.form.controls.payment_type_id.value);
    }

    public onChangePaymentType(typeTypeId: number) {
        if (typeTypeId == PAYMENT_TYPES.CREDIT) {
            this.form.controls.credit_terms.setValidators([Validators.min(1), Validators.integer, Validators.required])
        } else {
            this.form.controls.credit_terms.setValidators([Validators.min(1), Validators.integer]);
            if (this.form.controls.credit_terms.invalid) {
                this.form.controls.credit_terms.setValue(null)
            }
        }
    }

    public getFirstFormGroupErrorLabel(form: UntypedFormGroup) {
        let formValidationErrors = new FormValidationErrorsHelper();
        return formValidationErrors.getFirstErrorFormLabel(form);
    }

    public showErrorBlock(control: AbstractControl): boolean {
        return control.errors && (control.dirty || control.touched);
    }

    public getFormGroupErrorClasses(control: AbstractControl): {} {
        return {
            'is-invalid': control.invalid && control.touched
        };
    }
}
